import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import socketReducers from "./reducers/socket.reducer";
import mapLayersPopupReducers from "./reducers/mapLayerPopup.reducer";
import menuReducers from "./reducers/menu.reducer";
import searchReducers from "./reducers/search.reducer";
import mapReducers from "./reducers/map.reducer";
import authReducers from "./reducers/auth.reducer";

const reducer = combineReducers({
  socket: socketReducers,
  mapLayersPopup: mapLayersPopupReducers,
  menu: menuReducers,
  search: searchReducers,
  map: mapReducers,
  auth: authReducers
});

const composeEnhancers = compose; // trace
const store = createStore(
  reducer,
  undefined,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
